/**
 * What to do when a conversation opens with `?connected=<card>` after a provider sign-in:
 * - `wait` until the conversation's events have been fetched (`isLoaded`), or while a run is in progress;
 * - `continue` when the card is connected (the OAuth callback recorded it) and nothing ran since:
 *   answer it and let Pieve go on;
 * - `drop` otherwise (the sign-in did not finish, the card is not in this conversation, or the
 *   conversation already went on): only the key leaves the address.
 */
const resolveConnectionReturn = ({ blocks, interactionId, isLoaded, isRunning }) => {
  if (!isLoaded) {
    return 'wait';
  }

  const block = blocks.find((candidate) => candidate.kind === 'connection' && candidate.connection.interactionId === interactionId);

  if (!block || block.connection.outcome !== 'connected' || block.conversationMovedOn) {
    return 'drop';
  }

  return isRunning ? 'wait' : 'continue';
};

export default resolveConnectionReturn;
